<template>



    <v-row v-if="ready">
        <v-col cols="9">
            <v-slider v-model="opacityVal" color="primary" track-color="secondary" min="0" :max="sliderMultiplyer" ></v-slider>
        </v-col>
        <v-col cols="3">
            <v-switch :value="switchVal" @change="setVisible" inset color="secondary"></v-switch>
        </v-col>
    </v-row>

</template>

<script>
import { Layer } from 'ol/layer';
import LayerGroup from 'ol/layer/Group';

export default {

    props: {

        layer: {
            type: [Layer, LayerGroup],
            default: null,
        },
    },
    data: () => ({
        switchVal : null,
        opacityVal : null,
        sliderMultiplyer : 100,
        ready : false,
    }),


    mounted() {

        this.$nextTick(() => {
             this.switchVal = this.layer.getVisible();
        });

        this.opacityVal = this.layer.getOpacity() * this.sliderMultiplyer;

        this.ready = true;
       
    },


    methods: {
        setVisible(visible) {
            this.layer.setVisible(visible);
        },

    },
    watch: {

        // done with watcher so it updates before mouse release
        opacityVal: function() {
            this.layer.setOpacity(this.opacityVal/this.sliderMultiplyer)
        },
    }


};
</script>
